module.exports = "<a>{{moment(this.params.value)}}</a>\r\n"